import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import ReactCountryFlag from 'react-country-flag';
import { Tooltip, ButtonBase, Breadcrumbs, Tab, Tabs, Slider, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/AlternateEmail';
import ArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import RoofingIcon from '@mui/icons-material/Roofing';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Screen, Button, Logo, Message } from '../components';
import {__, request, toNumber, formatAmount, getCustomization, getCurrency} from '../functions';
import {
    IMAGES,
    ESHOPS,
    ESHOP_COLORS,
    ACCOUNTINGS,
    ACCOUNTING_COLORS,
    COURIERS,
    COURIER_COLORS,
    BANKS,
    BANK_COLORS,
    GATEWAYS,
    GATEWAYS_COLORS,
    STORAGES,
    STORAGE_COLORS,
    MARKETPLACES,
    MARKETPLACES_COLORS,
    PRICE,
    DEMO_TOKEN,
    COOKIE_TOKEN_NAME,
    COOKIE_SETTINGS,
    MARKET,
    PRICE_CZ,
    PRICE_PL,
    PRICE_HU,
    COOKIE_READ_NAME,
    ESHOP_POSITIONS,
    COURIER_POSITIONS,
    ACCOUNTING_POSITIONS,
    BANK_POSITIONS,
    GATEWAYS_POSITIONS,
    MARKETPLACES_POSITIONS,
    COOKIE_SOURCE_NAME,
    MANUAL_PRICE,
    MANUAL_PRICE_CZ,
    MANUAL_PRICE_HU,
    MANUAL_PRICE_PL,
} from '../config';
import '../assets/styles/public.css';

/**
 * Public.
 */
class PublicScreen extends Screen {
    /**
     * Auth required.
     *
     * @type {boolean}
     */
    authRequired = false;

    /**
     * Default state.
     *
     * @type {Object}
     */
    state = {
        scroll: false,
        stats: {},
        affiliate: false,
        branding: false,
        blog: false,
        blogArticle: null,
        blogCategory: 'all',
        cases: false,
        casesArticle: null,
        readCookies: true,
        tab: 'orders',
        lightbox: {
            affiliate: false,
            branding: false,
        },
        affiliateClients: 20,
        closeIntegration: false,
    };

    /**
     * Blog kategorie.
     *
     * @type {Object}
     */
    blogCategories = {
        all: __('Všetko'),
        eshops: __('Eshopy'),
        accountings: __('Ekonomické systémy'),
        storages: __('Sklady'),
        functions: __('Funkcie'),
        //gateways: __('Platobné brány'),
    };

    cases = {
        'meetyshop': {
            id: 1,
            uri: 'meetyshop',
            url: 'https://www.meetyshop.com',
            urlName: 'meetyshop.com',
            countries: ['sk', 'cz', 'us'],
            name: __('Prepojenie s dodávateľmi a internými systémami'),
            short: (<><div>{__('Prepojili sme klientov Upgates eshop s interným systémom ESO9, napojili dodávateľské XML feedy na automatickú aktualizáciu skladov a vyvinuli nástroj na sledovanie zmien cien.')}</div><div>{__('Vďaka automatizácii získal spoľahlivý systém bez manuálnych chýb a lepšiu kontrolu nad predajom.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkoval eshop na platforme <strong>Upgates</strong> a interný systém <strong>ESO9</strong>. Hľadal riešenie, ako tieto dva systémy efektívne prepojiť a zároveň zautomatizovať:</p><ul><li>správu objednávok a produktov</li><li>aktualizáciu skladových zásob od viacerých dodávateľov</li><li>kontrolu zmien cien a precenenie produktov</li></ul><h2>Naše riešenie</h2><p>Pripravili sme pre klienta komplexnú integráciu s viacerými funkciami:</p><h2>1. Prepojenie Upgates a ESO9</h2><ul><li>Automatický prenos objednávok z eshopu do ESO9</li><li>Synchronizácia produktov a ich aktualizácií z ESO9 do Upgates</li><li>Dvojcestná synchronizácia stavov objednávok</li></ul><h2>2. Automatická aktualizácia skladových zásob</h2><ul><li>Napojenie na externé <strong>XML feedy dodávateľov</strong></li><li>Pravidelná aktualizácia skladových zásob na pozadí bez nutnosti manuálneho zásahu</li></ul><h2>3. Inteligentné sledovanie zmien cien</h2><ul><li>Vyvinutý systém na monitoring zmien cien od dodávateľov</li><li>Prehľadné zobrazenie produktov, ktoré je potrebné preceňovať</li></ul><h2>Výsledok</h2><ul><li>Úspora času a minimalizácia chýb vďaka automatizácii procesov</li><li>Aktuálne dáta o skladových zásobách a cenách v reálnom čase</li><li>Rýchlejšia a efektívnejšia správa eshopu</li><li>Vyššia spokojnosť zákazníkov vďaka presným a aktuálnym informáciám</li></ul>'),
        },
        'dobrezeleziarstvo': {
            id: 2,
            uri: 'dobrezeleziarstvo',
            url: 'https://www.dobrezeleziarstvo.sk',
            urlName: 'dobrezeleziarstvo.sk',
            countries: ['sk', 'cz'],
            name: __('Systém pre správu odberných miest a objednávok'),
            short: (<><div>{__('Pre klienta so sieťou predajných miest sme vytvorili systém na správu odberov a objednávok, vrátane WooCommerce pluginu na výber predajného miesta cez mapu.')}</div><div>{__('Predajcovia spravujú svoje objednávky online, klient eviduje aj reklamácie a zákaznícke objednávky.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkuje sieť vlastných predajných miest, kde si jeho zákazníci môžu osobne vyzdvihnúť objednávky z eshopu. Potreboval efektívne riešenie na:</p><ul><li>správu odberných miest</li><li>integráciu výberu predajcu priamo v eshope</li><li>správu a sprístupnenie objednávok jednotlivým predajcom</li><li>evidenciu vlastných zákazníckych objednávok a reklamácií</li></ul><h2>Naše riešenie</h2><p>Pripravili sme komplexné riešenie pozostávajúce z viacerých častí:</p><h2>1. Správa odberných miest</h2><ul><li>Vytvorili sme interný systém na evidenciu predajných miest</li><li>Predajcovia majú vlastný prístup do systému, kde vidia objednávky pridelené ich predajni</li></ul><h2>2. Plugin pre WooCommerce eshop</h2><ul><li>Vyvinuli sme plugin, ktorý v pokladni zobrazuje mapu predajných miest s možnosťou výberu odberného miesta zákazníkom</li></ul><h2>3. Správa objednávok pre predajcov</h2><ul><li>Predajcovia vidia objednávky doručené do ich predajne</li><li>Môžu meniť stav objednávok a overiť správnosť PIN kódu pri vyzdvihnutí objednávky</li></ul><h2>4. Evidencia zákazníckych objednávok a reklamácií</h2><ul><li>Systém umožňuje aj internú evidenciu vlastných zákazníckych objednávok a správu reklamácií</li></ul><h2>Výsledok</h2><ul><li>Zákazníci si pohodlne vyberajú miesto osobného odberu priamo v eshope</li><li>Predajcovia majú prehľad o svojich objednávkach a rýchlo vybavujú zákazníkov</li><li>Klient získal plnú kontrolu nad objednávkami, predajňami a procesom reklamácií</li></ul>'),
        },
        'rezztek': {
            id: 3,
            uri: 'rezztek',
            url: 'https://rezztek.com',
            urlName: 'rezztek.com',
            countries: ['us', 'ca', 'eu'],
            name: __('Globálna fakturácia a doprava'),
            short: (<><div>{__('Pre klienta s globálnym predajom cez Shopify sme vytvorili systém na automatickú fakturáciu do SuperFaktúry pre USA, Kanadu a EÚ, a prepojili sme mu eshop s FedExom na celosvetovú dopravu.')}</div><div>{__('Zákazníci dostávajú faktúry aj zásielky rýchlo a spoľahlivo.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient predáva cez <strong>Shopify</strong> do viacerých krajín, najmä v <strong>USA, Kanade a Európe</strong>. Potreboval zabezpečiť:</p><ul><li>automatickú fakturáciu v systéme <strong>SuperFaktúra</strong> s prispôsobením pre jednotlivé trhy</li><li>prepojenie so službou <strong>FedEx</strong> na medzinárodnú expedíciu zásielok</li></ul><h2>Naše riešenie</h2><h2>1. Automatická fakturácia cez SuperFaktúru</h2><ul><li>Vytvorili sme prepojenie medzi <strong>Shopify</strong> a <strong>SuperFaktúrou</strong></li><li>Faktúry sa generujú automaticky po dokončení objednávky</li><li>Prispôsobili sme štruktúru faktúr podľa legislatívnych požiadaviek pre USA, Kanadu a Európu (napr. mena, sadzby DPH, adresné údaje)</li></ul><h2>2. Doprava cez FedEx</h2><ul><li>Zabezpečili sme napojenie na <strong>FedEx API</strong> pre automatizovanú expedíciu zásielok do celého sveta</li><li>Generovanie štítkov, sledovanie zásielok a odosielanie prebieha priamo zo systému</li></ul><h2>Výsledok</h2><ul><li>Klient má plne automatizovanú fakturáciu pre viacero trhov</li><li>Medzinárodné objednávky vybavuje rýchlo a bez nutnosti manuálneho zásahu</li><li>Zákazníci dostávajú faktúry aj zásielky rýchlo a spoľahlivo</li></ul>'),
        },
        'gigaplaza': {
            id: 4,
            uri: 'gigaplaza',
            url: 'https://gigaplaza.eu',
            urlName: 'gigaplaza.eu',
            countries: ['sk', 'hu'],
            name: __('Automatizácia fakturácie a odosielanie zásielok'),
            short: (<><div>{__('Pre klienta sme vytvorili systém na automatickú fakturáciu z eshopu Shoprenter do Money S3, vrátane prenosu PDF faktúr, napojenia na Maďarskú poštu (MPL) a špeciálnych funkcií ako stornovanie zásielok a tlač preberacích protokolov.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkuje eshop na platforme <strong>Shoprenter</strong> a potreboval riešiť:</p><ul><li>automatickú fakturáciu v systéme <strong>Money S3</strong></li><li>prenos vygenerovaných <strong>PDF faktúr</strong> späť do eshopu</li><li>napojenie na <strong>Maďarskú poštu (MPL)</strong> na odosielanie zásielok</li><li>špecifické požiadavky ako stornovanie zásielok a tlač preberacích protokolov</li></ul><h2>Naše riešenie</h2><p>Pripravili sme riešenie, ktoré pokrýva všetky požiadavky klienta:</p><h2>1. Automatická fakturácia a prenos faktúr</h2><ul><li>Automatické generovanie faktúr v <strong>Money S3</strong> na základe objednávok z eshopu</li><li>Automatický prenos <strong>PDF faktúr</strong> späť do Shoprenteru, aby boli dostupné pre zákazníkov</li></ul><h2>2. Integrácia s Maďarskou poštou (MPL)</h2><ul><li>Prepojenie eshopu s <strong>MPL</strong> na odosielanie zásielok</li><li>Automatizované vytváranie zásielok priamo zo systému</li></ul><h2>3. Funkcie na mieru</h2><ul><li>Implementácia možnosti <strong>stornovania zásielky</strong> priamo zo systému</li><li>Možnosť <strong>tlače preberacích protokolov</strong> podľa štandardov Maďarskej pošty</li></ul><h2>Výsledok</h2><ul><li>Plne automatizovaný proces fakturácie a správy zásielok</li><li>Menej manuálnych zásahov, vyššia rýchlosť vybavovania objednávok</li><li>Komfortné riešenie pre administrátorov aj zákazníkov</li></ul>'),
        },
        'cabshop': {
            id: 5,
            uri: 'cabshop',
            url: 'https://cabshop.sk',
            urlName: 'cabshop.sk',
            countries: ['sk', 'cz', 'pl', 'hu', 'si'],
            name: __('Migrácia eshopov a prepojenie s trhoviskami'),
            short: (<><div>{__('Klientovi sme zjednotili slovenský a český WooCommerce eshop do Upgates multijazyčného riešenia, spustili nové lokalizácie, prepojili ho s trhoviskami Allegro, Mall, Kaufland, a zaviedli automatickú fakturáciu cez SuperFaktúru pre každú krajinu.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkoval dva samostatné eshopy na platforme <strong>WooCommerce</strong> pre <strong>Slovensko a Česko</strong> a plánoval expanziu do ďalších krajín. Zároveň potreboval prepojiť nový systém s <strong>trhoviskami</strong> a vyriešiť automatickú <strong>fakturáciu</strong> pre viaceré lokalizácie.</p><h2>Naše riešenie</h2><h2>1. Migrácia a expanzia</h2><ul><li>Premigrovali sme slovenský a český eshop z <strong>WooCommerce</strong> do jedného multijazyčného riešenia na <strong>Upgates</strong></li><li>Spustili sme ďalšie lokalizácie pre <strong>Maďarsko, Slovinsko a Poľsko</strong></li><li>eshop teraz funguje ako centrálne riešenie s lokalizovaným obsahom, menou a nastaveniami</li></ul><h2>2. Automatická fakturácia</h2><ul><li>Zabezpečili sme prepojenie s <strong>SuperFaktúrou</strong></li><li>Fakturácia prebieha automaticky a je prispôsobená pre každú lokalitu – jazyk, sadzby DPH, formáty faktúr</li></ul><h2>3. Napojenie na trhoviská</h2><ul><li>eshop sme prepojili s trhoviskami <strong>Allegro, Mall a Kaufland</strong></li><li>Načítavame nové objednávky z týchto trhovísk do systému</li><li>Po prijatí objednávky sa automaticky <strong>odpočítava sklad</strong> na eshope a zároveň sa sklad spätne <strong>aktualizuje na trhoviskách</strong></li><li>Klient má k dispozícii nástroj na <strong>precenenie produktov</strong> špecificky pre trhoviská</li></ul><h2>Výsledok</h2><ul><li>Klient má centralizovaný systém, ktorý zvláda správu viacerých lokalizácií a trhovísk</li><li>Objednávky, fakturácia aj sklad sú plne automatizované</li><li>Vďaka tejto infraštruktúre u nás klient spravuje <strong>ďalších 5 eshopov</strong></li></ul>'),
        },
        'vsetkopreokna': {
            id: 6,
            uri: 'vsetkopreokna',
            url: 'https://vsetkopreokna.sk',
            urlName: 'vsetkopreokna.sk',
            countries: ['sk', 'cz'],
            name: __('Evidencia zákaziek a automatizácia fakturácie'),
            short: (<><div>{__('Prepojili sme WooCommerce eshop s Pohodou, automatizovali vystavovanie faktúr a dobropisov, zaviedli upomienky za skladovanie, a vytvorili evidenciu objednávok na mieru s cenovými ponukami vo formáte PDF.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkuje eshop na <strong>WooCommerce</strong> a potreboval <strong>automatizovať fakturáciu</strong> v systéme <strong>Pohoda</strong>, vrátane riešenia špecifických procesov ako skladovanie neprevzatých zásielok či spracovanie objednávok na mieru.</p><h2>Naše riešenie</h2><h2>1. Prepojenie WooCommerce s Pohodou</h2><ul><li>Zabezpečili sme obojsmerné prepojenie medzi <strong>eshopom a systémom Pohoda</strong></li><li>Automaticky vystavujeme <strong>klasické faktúry</strong> aj <strong>dobropisy</strong>, ktoré sú následne <strong>zasielané emailom zákazníkom</strong></li><li>Fakturačný proces prebieha bez potreby manuálneho zásahu</li></ul><h2>2. Automatické faktúry a upomienky za skladovanie</h2><ul><li>Vytvorili sme modul, ktorý automaticky generuje a odosiela <strong>faktúry za skladovanie neprevzatých zásielok</strong></li><li>Súčasťou sú aj <strong>upomienky</strong> pre zákazníkov s neprevzatými objednávkami</li></ul><h2>3. Evidencia objednávok na mieru</h2><ul><li>Klient môže v internom systéme vytvoriť <strong>objednávku na žalúzie a sieťky na okná</strong></li><li>Interný systém umožňuje klientovi spravovať tieto zákazky a vytvárať k nim <strong>prehľadné PDF cenové ponuky</strong> s presnými <strong>rozmermi tovaru</strong></li></ul><h2>Výsledok</h2><ul><li>Kompletná automatizácia fakturácie a komunikácie so zákazníkom</li><li>Evidencia špecifických zákaziek s výstupmi vo forme PDF</li><li>Zníženie administratívnej záťaže a vyšší komfort pre zákazníkov</li></ul>'),
        },
        'ebenica': {
            id: 7,
            uri: 'ebenica',
            url: 'https://ebenica.sk',
            urlName: 'ebenica.sk',
            countries: ['sk', 'cz', 'hu', 'pl'],
            name: __('Multilokalizačný e-commerce s automatizáciou'),
            short: (<><div>{__('Pre klienta sme prepojili viacero WooCommerce eshopov so SuperFaktúrou, dopravcami Packeta, DPD, GLS, zaviedli automatické párovanie platieb z banky a nastavili denné exporty objednávok do Excelu odosielané emailom.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkuje viacero lokalizačných eshopov na platforme <strong>WooCommerce</strong>. Potreboval:</p><ul><li>automatizovať fakturáciu cez <strong>SuperFaktúru</strong> pre každú krajinu a legislatívu (vrátane <strong>OSS</strong>)</li><li>prepojiť odosielanie zásielok cez <strong>Packeta, DPD a GLS</strong></li><li>automaticky <strong>párovať platby z banky</strong></li><li>vytvoriť <strong>denné exporty objednávok v Exceli</strong> odosielané priamo na email</li></ul><h2>Naše riešenie</h2><h2>1. Automatická fakturácia cez SuperFaktúru</h2><ul><li>Každý WooCommerce eshop pre konkrétnu lokalizáciu sme prepojili so <strong>SuperFaktúrou</strong></li><li>Nastavili sme fakturáciu na mieru podľa legislatívy danej krajiny vrátane pravidiel <strong>OSS</strong> (One Stop Shop)</li><li>Proces vystavovania faktúr prebieha plne automaticky</li></ul><h2>2. Prepojenie s dopravcami</h2><ul><li>Implementovali sme napojenie na <strong>Packeta, DPD a GLS</strong> pre automatizované odosielanie zásielok</li><li>Zásielky sa vytvárajú priamo zo systému bez manuálneho zásahu</li></ul><h2>3. Automatické párovanie platieb</h2><ul><li>Platby prijaté na bankový účet sa automaticky spárujú s príslušnými objednávkami</li><li>Znížilo sa riziko chýb a zrýchlilo spracovanie objednávok</li></ul><h2>4. Denné exporty objednávok</h2><ul><li>Vyvinuli sme systém na <strong>automatické generovanie Excel reportov</strong> s prehľadom objednávok</li><li>Exporty sa každý deň automaticky odosielajú na zadané emailové adresy</li></ul><h2>Výsledok</h2><ul><li>Klient má plne automatizovaný a prehľadný systém pre správu objednávok, fakturácie, dopravy aj platieb</li><li>Administratívna záťaž sa výrazne znížila</li><li>Procesy sú jednotné pre všetky lokalizačné eshopy</li></ul>'),
        },
        'rainpro': {
            id: 8,
            uri: 'rainpro',
            url: 'https://rainpro.sk',
            urlName: 'rainpro.sk',
            countries: ['sk'],
            name: __('Efektívna správa objednávok, skladníkov a logistiky'),
            short: (<><div>{__('Pre klienta sme vyvinuli systém na evidenciu skladníkov, prepojili Biznisweb eshop so SuperFaktúrou, automatizovali párovanie platieb z GoPay a Fio banky a odosielanie zásielok cez Packetu a SDS.')}</div></>),
            text: __('<h2>Výzva</h2><p>Klient prevádzkuje eshop na platforme <strong>Biznisweb</strong> a potreboval:</p><ul><li>zaviesť systém na <strong>evidenciu a prácu skladníkov</strong></li><li>automatizovať <strong>fakturáciu cez SuperFaktúru</strong></li><li>prepojiť logistiku na <strong>Packetu a SDS</strong></li><li>automaticky <strong>párovať platby z GoPay a Fio banky</strong></li></ul><h2>Naše riešenie</h2><h2>1. Systém pre evidenciu skladníkov</h2><ul><li>Vyvinuli sme systém, ktorý umožňuje priradiť konkrétnu objednávku konkrétnemu <strong>skladníkovi</strong></li><li>Skladník má prehľad o svojich objednávkach a vie, ktorému prepravcovi ich odovzdať</li></ul><h2>2. Automatická fakturácia cez SuperFaktúru</h2><ul><li>Prepojili sme <strong>Biznisweb eshop</strong> so <strong>SuperFaktúrou</strong></li><li>Faktúry sa vystavujú a odosielajú automaticky</li></ul><h2>3. Prepojenie s prepravcami</h2><ul><li>Automatické napojenie na <strong>Packetu a SDS</strong> na odosielanie zásielok</li></ul><h2>4. Párovanie platieb</h2><ul><li>Platby z <strong>GoPay</strong> a <strong>Fio banky</strong> sa automaticky spárujú s objednávkami</li></ul><h2>Výsledok</h2><ul><li>Automatizácia správy objednávok, skladníkov, fakturácie a logistiky</li><li>Nižšia administratívna náročnosť a vyššia efektivita</li><li>Jasná evidencia a rozdelenie práce medzi skladníkov</li></ul>'),
        },
    };

    /**
     * Clanky.
     *
     * @type {Object}
     */
    blogArticles = {
        'eshop-woocommerce': {
            id: 1,
            uri: 'eshop-woocommerce',
            category: 'eshops',
            name: __('Ako prepojiť WooCommerce eshop?'),
            text: __('<p>Pre API prepojenie bude náš systém potrebovať Kľúč zákazníka (Consumer key) a Tajomstvo zákazníka (Consumer secret). Nižšie nájdete postup ako ich vygenerovať.</p><p><img src="{IMAGE1}" /></p><p>Vyplňte názov, zvoľte používateľa a nastavte práva na "Čítať / Zapísať".</p><p><img src="{IMAGE2}" /></p><p>Po vygenerovaní sa vám zobrazí Kľúč zákazníka (Consumer key) a Tajomstvo zákazníka (Consumer secret).</p><p><img src="{IMAGE3}" /></p>').replace('{IMAGE1}', IMAGES['eshop-woocommerce-1.jpg']).replace('{IMAGE2}', IMAGES['eshop-woocommerce-2.jpg']).replace('{IMAGE3}', IMAGES['eshop-woocommerce-3.jpg']),
            background: '#8154b1',
        },
        'accounting-omega': {
            id: 2,
            uri: 'accounting-omega',
            category: 'accountings',
            name: __('Ako prepojiť fakturáciu s Omegou?'),
            text: __('<p>Pre prepojenie nášho systému s Omegou využívame ich službu <a href="https://kros.sk/fakturacia" target="_blank">https://kros.sk/fakturacia</a> kde je potrebné aby ste mali ich PRO balík.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú online fakturáciu</li><li>Zasielanie faktúr emailom</li><li>Evidenciu a párovanie úhrad</li></ul></p><p><h2>1. Registrácia v KROS fakturácii</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii KROS fakturácia <a href="https://fakturacia.kros.sk/" target="_blank">na tejto stránke</a>.</p><p><h2>2. Nastavenie synchronizácie s Omegou</h2></p><p>Nižšie na obrázku vidíte postup ako jednoducho nastaviť prepojenie aplikácie KROS fakturácia s Omegou. Prvýkrát pri využívaní tejto služby je potrebné sa prihlásiť pod kontom užívateľa ktorým ste sa registrovali do aplikácie KROS fakturácia, potom už sťahovanie bude fungovať bez prihlásenia.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Prepojenie s našim systémom</h2></p><p>V sekcii Ekonomický systém si u nás vyberiete aplikáciu Omega a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie KROS fakturácia. To je celé. Od tohto momentu môže náš systém vystavovať faktúry v aplikácii KROS fakturácia s následnou synchronizáciou do Omegy.</p><p><img src="{IMAGE2}" /></p>').replace('{IMAGE1}', IMAGES['accounting-omega-1.jpg']).replace('{IMAGE2}', IMAGES['accounting-omega-2.jpg']),
            background: '#005ca8',
        },
        'accounting-pohoda': {
            id: 3,
            uri: 'accounting-pohoda',
            category: 'accountings',
            name: __('Ako prepojiť fakturáciu s Pohodou?'),
            text: __('<p>Pre prepojenie nášho systému s Pohodou využívame ich službu <a href="https://mpohoda.sk" target="_blank">https://mpohoda.sk</a> ktorá je zadarmo pre majiteľov softvéru Pohoda.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú online fakturáciu</li><li>Zasielanie faktúr emailom</li><li>Evidenciu a párovanie úhrad</li></ul></p><p><h2>1. Registrácia v mPOHODA</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii mPOHODA <a href="https://app.mpohoda.sk/ucet/registrace" target="_blank">na tejto stránke</a>.</p><p><h2>2. Nastavenie synchronizácie s Pohodou</h2></p><p>Nižšie na obrázku vidíte postup ako jednoducho nastaviť prepojenie aplikácie mPOHODA s Pohodou. V Globálnom nastavení v  sekcii mPOHODA zaškrtnite voľbu Povoliť komunikáciu. Potom už len vyplňte prihlasovacie meno (e-mail) a heslo, pod ktorými ste sa registrovali na webovom rozhraní aplikácie mPOHODA.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Prepojenie s našim systémom</h2></p><p>V sekcii Ekonomický systém si u nás vyberiete aplikáciu Pohoda a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie mPOHODA. To je celé. Od tohto momentu môže náš systém vystavovať faktúry v aplikácii mPOHODA s následnou synchronizáciou do Pohody.</p><p><img src="{IMAGE2}" /></p>').replace('{IMAGE1}', IMAGES['accounting-pohoda-1.gif']).replace('{IMAGE2}', IMAGES['accounting-pohoda-2.jpg']),
            background: '#004389',
        },
        'accounting-mrp': {
            id: 4,
            uri: 'accounting-mrp',
            category: 'accountings',
            name: __('Ako prepojiť fakturáciu s MRP?'),
            text: __('<p>Pre prepojenie nášho systému s MRP využívame ich službu <a href="https://turbofaktura.sk" target="_blank">https://turbofaktura.sk</a> ktorá je zadarmo.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú online fakturáciu</li><li>Zasielanie faktúr emailom</li><li>Evidenciu a párovanie úhrad</li></ul></p><p><h2>1. Registrácia v Turbofaktúre</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii Turbofaktúra <a href="https://www.turbofaktura.sk/registrace/" target="_blank">na tejto stránke</a>.</p><p><h2>2. Prepojenie s našim systémom</h2></p><p>V sekcii Ekonomický systém si u nás vyberiete aplikáciu MRP a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie Turbofaktúra. To je celé. Od tohto momentu môže náš systém vystavovať faktúry v aplikácii Turbofaktúra s následnou synchronizáciou do MRP.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Synchronizácia s MRP</h2></p><p>Nižšie na obrázku vidíte ako jednoducho prebieha import faktúr z aplikácie Turbofaktúra do MRP. Stačí kliknúť v MRP na tlačítko Turbofaktúra.</p><p><img src="{IMAGE2}" /></p>').replace('{IMAGE1}', IMAGES['accounting-mrp-1.jpg']).replace('{IMAGE2}', IMAGES['accounting-mrp-2.png']),
            background: 'white',
        },
        'accounting-moneys3': {
            id: 5,
            uri: 'accounting-moneys3',
            category: 'accountings',
            name: __('Ako prepojiť fakturáciu s Money S3?'),
            text: __('<p>Pre prepojenie nášho systému s Money S3 využívame ich službu <a href="https://idoklad.sk" target="_blank">https://idoklad.sk</a> kde je potrebné aby ste mali ich Prémiové predplatné ktoré podporuje API.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú online fakturáciu</li><li>Zasielanie faktúr emailom</li><li>Evidenciu a párovanie úhrad</li></ul></p><p><h2>1. Registrácia v iDoklade</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii iDoklad <a href="https://app.idoklad.sk/Account/Registration" target="_blank">na tejto stránke</a>.</p><p><h2>2. Prepojenie s našim systémom</h2></p><p>V sekcii Ekonomický systém si u nás vyberiete aplikáciu iDoklad a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie iDoklad. To je celé. Od tohto momentu môže náš systém vystavovať faktúry v aplikácii iDoklad s následnou synchronizáciou do Money S3.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Synchronizácia s Money S3</h2></p><p><a href="https://www.idoklad.sk/pub/Help/index.html?1_prepojenie_s_money_s3.html" target="_blank">Na tejto stránke</a> nájdete postup ako nastaviť synchronizáciu dát medzi iDokladom a Money S3.</p>').replace('{IMAGE1}', IMAGES['accounting-money-1.jpg']),
            background: 'white',
        },
        'accounting-moneys4': {
            id: 6,
            uri: 'accounting-moneys4',
            category: 'accountings',
            name: __('Ako prepojiť fakturáciu s Money S4?'),
            text: __('<p>Pre prepojenie nášho systému s Money S4 využívame ich službu <a href="https://idoklad.sk" target="_blank">https://idoklad.sk</a> kde je potrebné aby ste mali ich Prémiové predplatné ktoré podporuje API.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú online fakturáciu</li><li>Zasielanie faktúr emailom</li><li>Evidenciu a párovanie úhrad</li></ul></p><p><h2>1. Registrácia v iDoklade</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii iDoklad <a href="https://app.idoklad.sk/Account/Registration" target="_blank">na tejto stránke</a>.</p><p><h2>2. Prepojenie s našim systémom</h2></p><p>V sekcii Ekonomický systém si u nás vyberiete aplikáciu iDoklad a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie iDoklad. To je celé. Od tohto momentu môže náš systém vystavovať faktúry v aplikácii iDoklad s následnou synchronizáciou do Money S4.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Synchronizácia s Money S4</h2></p><p><a href="https://www.idoklad.sk/pub/Help/index.html?1_prepojenie_s_money_s4_s5.html" target="_blank">Na tejto stránke</a> nájdete postup ako nastaviť synchronizáciu dát medzi iDokladom a Money S4.</p>').replace('{IMAGE1}', IMAGES['accounting-money-1.jpg']),
            background: 'white',
        },
        'storage-pohoda': {
            id: 8,
            uri: 'storage-pohoda',
            category: 'storages',
            name: __('Ako prepojiť sklad s Pohodou?'),
            text: __('<p>Pre prepojenie nášho systému s Pohodou využívame ich službu <a href="https://mpohoda.sk" target="_blank">https://mpohoda.sk</a> ktorá je zadarmo pre majiteľov softvéru Pohoda.</p><p>Čo získate týmto prepojením?</p><p><ul><li>Automatickú synchronizáciu stavov na sklade</li><li>Automatickú synchronizáciu cien, názvov produktov a pod</li><li>Vytváranie nových produktov v eshope</li><li>Import prijatých objednávok</li></ul></p><p><h2>1. Registrácia v mPOHODA</h2></p><p>Najprv si musíte vytvoriť účet v aplikácii mPOHODA <a href="https://app.mpohoda.sk/ucet/registrace" target="_blank">na tejto stránke</a>.</p><p><h2>2. Nastavenie synchronizácie s Pohodou</h2></p><p>Nižšie na obrázku vidíte postup ako jednoducho nastaviť prepojenie aplikácie mPOHODA s Pohodou. V Globálnom nastavení v  sekcii mPOHODA zaškrtnite voľbu Povoliť komunikáciu. Potom už len vyplňte prihlasovacie meno (e-mail) a heslo, pod ktorými ste sa registrovali na webovom rozhraní aplikácie mPOHODA.</p><p><img src="{IMAGE1}" /></p><p><h2>3. Nastavenie synchronizácie skladov</h2></p><p>V Pohode je ešte potrebné zašktnúť nastavenie "Synchronizácia zásob s mPOHODA" pri skladoch ktoré potrebujete synchronizovať.</p><p><img src="{IMAGE3}" /></p><p><h2>4. Prepojenie s našim systémom</h2></p><p>V sekcii Sklad si u nás vyberiete aplikáciu Pohoda a zadáte prihlasovacie údaje pod ktorými ste sa registrovali na webovom rozhraní aplikácie mPOHODA. To je celé. Od tohto momentu môže náš systém synchronizovať skladové karty s produktami v eshope.</p><p><img src="{IMAGE2}" /></p>').replace('{IMAGE1}', IMAGES['accounting-pohoda-1.gif']).replace('{IMAGE2}', IMAGES['storage-pohoda-1.jpg']).replace('{IMAGE3}', IMAGES['storage-pohoda-2.jpg']),
            background: '#004389',
        },
        'eshop-shopify': {
            id: 9,
            uri: 'eshop-shopify',
            category: 'eshops',
            name: __('Ako prepojiť Shopify eshop?'),
            text: __('<p>Pre API prepojenie bude náš systém potrebovať API klúč a API heslo. Nižšie nájdete postup ako ich vygenerovať.</p><p><img src="{IMAGE1}" /></p><p><img src="{IMAGE2}" /></p><p><img src="{IMAGE3}" /></p><p><img src="{IMAGE4}" /></p><p><img src="{IMAGE5}" /></p><p><img src="{IMAGE6}" /></p><p>V tomto kroku musíte nastaviť práva ku ktorým bude môcť pristupovať náš systém cez API. Konkrétne treba aby ste mali zaškrtnuté tieto:</p><p><ul><li>write_assigned_fulfillment_orders</li><li>read_assigned_fulfillment_orders</li><li>write_customers</li><li>read_customers</li><li>write_draft_orders</li><li>read_draft_orders</li><li>write_fulfillments</li><li>read_fulfillments</li><li>write_inventory</li><li>read_inventory</li><li>write_order_edits</li><li>read_order_edits</li><li>write_orders</li><li>read_orders</li><li>write_product_listings</li><li>read_product_listings</li><li>write_products</li><li>read_products</li><li>read_shipping</li><li>write_shipping</li><li>write_merchant_managed_fulfillment_orders</li><li>read_merchant_managed_fulfillment_orders</li></ul></ul></p><p><img src="{IMAGE7}" /></p><p><img src="{IMAGE8}" /></p><p>Na tomto obrázku vidíte 2 údaje ktoré potrebuje náš systém. Prvý vyznačený údaj je API password a druhý vyznačený údaj je API klúč.</p><p><img src="{IMAGE9}" /></p>').replace('{IMAGE1}', IMAGES['eshop-shopify-1.jpg']).replace('{IMAGE2}', IMAGES['eshop-shopify-2.jpg']).replace('{IMAGE3}', IMAGES['eshop-shopify-3.jpg']).replace('{IMAGE4}', IMAGES['eshop-shopify-4.jpg']).replace('{IMAGE5}', IMAGES['eshop-shopify-5.jpg']).replace('{IMAGE6}', IMAGES['eshop-shopify-6.jpg']).replace('{IMAGE7}', IMAGES['eshop-shopify-7.jpg']).replace('{IMAGE8}', IMAGES['eshop-shopify-8.jpg']).replace('{IMAGE9}', IMAGES['eshop-shopify-9.jpg']),
            background: 'white',
        },
        'eshop-prestashop': {
            id: 10,
            uri: 'eshop-prestashop',
            category: 'eshops',
            name: __('Ako prepojiť Prestashop eshop?'),
            text: __('<p>Pre API prepojenie bude náš systém potrebovať API klúč. Nižšie nájdete postup ako ho vygenerovať.</p><p><img src="{IMAGE1}" /></p><p><img src="{IMAGE2}" /></p><p>V tomto kroku musíte nastaviť práva ku ktorým bude môcť pristupovať náš systém cez API. Konkrétne treba aby ste mali zaškrtnuté tieto:</p><p><ul><li>addresses</li><li>carriers</li><li>countries</li><li>currencies</li><li>customers</li><li>deliveries</li><li>images</li><li>order_carriers</li><li>order_details</li><li>order_histories</li><li>order_invoices</li><li>order_payments</li><li>order_slip</li><li>order_states</li><li>orders</li><li>product_customization_fields</li><li>product_feature_values</li><li>product_features</li><li>product_option_values</li><li>product_options</li><li>product_suppliers</li><li>products</li><li>stock_availables</li><li>stock_movement_reasons</li><li>stock_movements</li><li>stocks</li><li>stores</li><li>tax_rule_groups</li><li>tax_rules</li><li>taxes</li></ul></ul></p><p><img src="{IMAGE3}" /></p><p>Na tejto stránke nájdete vygenerovaný API klúč.</p><p><img src="{IMAGE4}" /></p>').replace('{IMAGE1}', IMAGES['eshop-prestashop-1.jpg']).replace('{IMAGE2}', IMAGES['eshop-prestashop-2.jpg']).replace('{IMAGE3}', IMAGES['eshop-prestashop-3.jpg']).replace('{IMAGE4}', IMAGES['eshop-prestashop-4.jpg']),
            background: 'white',
        },
        'eshop-upgates': {
            id: 11,
            uri: 'eshop-upgates',
            category: 'eshops',
            name: __('Ako prepojiť Upgates eshop?'),
            text: __('<p>Pre API prepojenie bude náš systém potrebovať API url adresu, API login a API klúč. Nižšie nájdete postup ako ho vygenerovať.</p><p><img src="{IMAGE1}" /></p>').replace('{IMAGE1}', IMAGES['eshop-upgates-0.jpg']),
            background: 'white',
        },
        'map': {
            id: 12,
            uri: 'map',
            category: 'functions',
            name: __('Univerzálna mapa výdajných miest pre váš eshop'),
            text: __('<p>Dajte svojim zákazníkom možnosť pohodlne si vybrať výdajné miesto od viacerých prepravcov priamo počas nákupu.</p><h2>Flexibilita bez obmedzení</h2><p>Kombinujte výdajné miesta od rôznych prepravcov do jednej prehľadnej mapy a zvýšte komfort vašich zákazníkov.</p><h2>Prispôsobenie podľa vašich potrieb</h2><ul><li>Filtrovanie podľa spôsobu platby (dobierka, platba kartou)</li><li>Výber typu výdajného miesta (klasické výdajné miesto, výdajný box)</li><li>Možnosť výberu a kombinácie prepravcov</li></ul><h2>Jednoduchá implementácia</h2><p>Stačí vložiť náš kód s mapou do vášho eshopu a okamžite ponúkate moderný spôsob výberu výdajného miesta.</p><p><strong>S nastavením vám naši kolegovia s radosťou pomôžu.</strong></p><h2>Výhody</h2><ul><li>Zvýšená spokojnosť zákazníkov</li><li>Nižšie percento nedoručených zásielok</li><li>Efektívnejšie spracovanie objednávok</li><li>Menej manuálnej práce</li></ul><h2>Ukážka mapy:</h2><p><iframe src="{MAP_URL}"></iframe></p>').replace('{MAP_URL}', `https://api.goodeshop.sk/map.php?token=${MARKET === 'cz' ? 'cea3c24c05bd99a8a783959731bf010be8ab2bb8' : '210b0521347f1605bcd76e962f0bea486f3ca4c8'}&shopify_token=public`),
            background: '#f3faff',
        },
    };

    /**
     * Tabs.
     *
     * @type {Object}
     */
    tabs = {
        orders: [
            { title: __('Všetky objednávky na jednom mieste'), text: (<><div>{__('Náš systém automaticky importuje a synchronizuje objednávky z vášho eshopu a trhovísk (Allegro, Kaufland, Heureka a pod.).')}</div><div>{__('Objednávky z trhovísk vieme priamo vytvoriť v eshope, aby sedel sklad. Ak je potrebné objednávku zaevidovať ručne, ani to nebude problém.')}</div></>) },
            { title: __('Pracujte s objednávkami jednoducho'), text: (<div>{__('U nás môžete jednoducho meniť stav objednávky, odoslať email zákazníkovi, vystaviť faktúru, zaevidovať úhradu, poslať objednávku prepravcovi alebo ju stiahnuť do PDF či Excelu.')}</div>) },
            { title: __('Automatizujte opakujúce sa procesy'), text: (<><div>{__('Zbavte sa ručného nastavovania stavov objednávok, odosielania emailov a vystavovania faktúr.')}</div><div>{__('Náš systém automaticky zmení stav objednávky a po vystavení faktúry, odoslaní či doručení zásielky odošle email zákazníkovi.')}</div></>) },
        ],
        invoices: [
            { title: __('Automatizácia fakturácie a účtovníctva'), text: (<><div>{__('Napojte sa na svoj fakturačný alebo účtovný systém a vystavujte faktúry jedným kliknutím alebo automaticky po zmene stavu objednávky.')}</div><div>{__('Rozlišujeme klasické, zálohové faktúry a dobropisy. Automatický email s faktúrou zákazníkovi je samozrejmosť.')}</div></>) },
            { title: __('Evidencia úhrad a párovanie platieb'), text: (<><div>{__('Zabezpečíme prehľadnú a automatickú evidenciu prijatých úhrad.')}</div><div>{__('Napojíme vás na vašu banku alebo platobnú bránu a automaticky priradíme platbu k objednávke alebo faktúre.')}</div></>) },
            { title: __('Zálohové faktúry s vyúčtovaním a dobropisy'), text: (<div>{__('Ak potrebujete vystavovať zálohové faktúry s vyúčtovaním alebo dobropisy po zrušení objednávky, náš systém to zvládne.')}</div>) },
        ],
        products: [
            { title: __('Synchronizácia produktov so skladom'), text: (<><div>{__('Napojte svoj externý skladový systém a náš systém automaticky synchronizuje produkty medzi skladom a eshopom.')}</div><div>{__('Aktualizuje ceny, skladové zásoby, názvy a ďalšie vlastnosti produktov. Ak produkt zo skladu ešte neexistuje v eshope, systém ho automaticky vytvorí.')}</div></>) },
            { title: __('Aktualizácia produktov na trhoviskách'), text: (<><div>{__('Ak používate trhoviská ako Allegro, Kaufland, Amazon, Etsy a pod., oceníte automatickú aktualizáciu skladových zásob a cien z eshopu na trhovisko.')}</div><div>{__('Nové produkty môžete jednoducho naimportovať na trhovisko na pár kliknutí.')}</div></>) },
            { title: __('Automatický import objednávok'), text: (<><div>{__('Náš systém umožňuje spätnú aktualizáciu údajov – importuje nové objednávky z eshopu do skladového systému.')}</div><div>{__('Ak používate trhoviská, systém vytvorí objednávky priamo v eshope, čím sa zabezpečí presnosť skladových zásob.')}</div></>) },
        ],
        packages: [
            { title: __('Všetci prepravcovia na jednom mieste'), text: (<><div>{__('Už sa nemusíte prihlasovať do systémov prepravcov. Cez naše prostredie jednoducho na pár kliknutí odošlete objednávky viacerým prepravcom naraz.')}</div><div>{__('Čísla zásielok a štítky sa automaticky stiahnu a pripravia na tlač.')}</div></>) },
            { title: __('Kontrola údajov pred odoslaním'), text: (<><div>{__('Náš systém automaticky opravuje údaje objednávok, napríklad pri nesprávnom formáte telefónneho čísla.')}</div><div>{__('Podporujeme aj kontrolu produktov cez skenovanie EAN kódov, aby ste mali istotu, že zásielka je správna.')}</div></>) },
            { title: __('Automatizácia procesov expedície'), text: (<><div>{__('Ušetrite čas automatizovaním opakovaných úkonov. Pri odoslaní zásielky cez náš systém automaticky stiahneme čísla zásielok, zmeníme stav objednávky, odošleme email zákazníkovi.')}</div><div>{__('Po doručení opäť aktualizujeme stav, odošleme ďalší email alebo vystavíme faktúru.')}</div></>) },
        ],
        track: [
            { title: __('Dajte možnosť zákaznikovi sledovať stav'), text: (<><div>{__('Ku každej objednávke poskytujeme verejnú stránku, ktorú môžete zaslať zákazníkovi.')}</div><div>{__('Na nej uvidí aktuálny stav objednávky, stiahne vystavenú faktúru, sleduje zásielku a v prípade potreby môže objednávku stornovať alebo reklamovať.')}</div></>) },
            { title: __('Evidencia reklamácii na jednom mieste'), text: (<><div>{__('Cez verejnú stránku môžu vaši zákazníci jednoducho reklamovať produkt. Reklamácia sa zobrazí v našom systéme, kde ju priradíte konkrétnemu zamestnancovi.')}</div><div>{__('Po vybavení reklamácie sa zákazníkovi zobrazí aktuálny stav a spôsob vybavenia.')}</div></>) },
            { title: __('Chcete vidieť ukážku z DEMO účtu?'), text: (<div dangerouslySetInnerHTML={{ __html: __('Kliknutím na tento <a href="{LINK}" target="_blank">odkaz</a> sa vám otvorí verejná stránka testovacej objednávky z nášho DEMO účtu.').replace('{LINK}', `https://goodeshop.${MARKET}/orders/public/1250263/d6bb0ecd135929dff875ac3922f185e81a07180e`) }} />) },
        ],
    };

    /**
     * Nahodne clanky.
     *
     * @type {Object|null}
     */
    shuffledArticles = null;

    shuffledCases = null;

    /**
     * Konstruktor.
     *
     * @param {Object} props
     */
    constructor(props) {
        super(props);

        this.infoRef = React.createRef();
        this.clientsRef = React.createRef();
        this.integrationRef = React.createRef();
        this.pricingRef = React.createRef();
        this.contactRef = React.createRef();
    }

    /**
     * Komponenta bola pripojena.
     *
     * @return boolean
     */
    async componentDidMount() {
        // Nacitame statistiky
        const path = this.getPath();

        if (path.indexOf('/set-token/') !== -1) {
            const { cookies } = this.props;

            // Ulozime token do cookie
            cookies.set(COOKIE_TOKEN_NAME, path.replace('/set-token/', ''), COOKIE_SETTINGS);

            window.location = '/dashboard';
            return;
        }

        const { source } = this.props;

        if (!_.isEmpty(source)) {
            // Mame zdroj, ulozime do cookie
            const { cookies } = this.props;

            // Ulozime source do cookie
            cookies.set(COOKIE_SOURCE_NAME, source, COOKIE_SETTINGS);
        }

        if (!super.componentDidMount()) {
            return false;
        }

        if (path.indexOf('/blog/') !== -1) {
            // Nacitavame clanok
            const blogArticle = path.replace('/blog/', '');

            if (_.has(this.blogArticles, blogArticle)) {
                this.setState({ blog: true, blogArticle });
            }
        } else if (path.indexOf('/cases/') !== -1) {
            // Nacitavame clanok
            const casesArticle = path.replace('/cases/', '');

            if (_.has(this.cases, casesArticle)) {
                this.setState({ cases: true, casesArticle });
            }
        } else if (path === '/blog') {
            // Nacitavame blog
            this.setState({ blog: true });
        } else if (path === '/cases') {
            // Nacitavame cases
            this.setState({ cases: true });
        } else if (path === '/affiliate') {
            // Nacitavame affiliate
            this.setState({ affiliate: true });
        } else if (path === '/branding') {
            // Nacitavame branding
            this.setState({ branding: true });
        }

        if (getCustomization() !== null) {
            // Ide o customizaciu
            window.location = '/login';
            return;
        }

        await request('/stats.php', false, 'GET', {}, false).then(response => {
            this.setState({ stats: response.data, readCookies: this.readCookies() });
        }).catch(error => {
            this.setState({ stats: { orders: 0, invoices: 0, packages: 0 }, readCookies: this.readCookies() });
        });

        // Pridame listener
        window.addEventListener('scroll', this.handleScroll);

        return true;
    }

    /**
     * Komponenta bude odpojena.
     */
    componentWillUnmount() {
        // Odstranime listener
        window.removeEventListener('scroll', this.handleScroll);
    }

    /**
     * Handlujeme scrolovanie.
     *
     * @param {Object} event
     */
    handleScroll = event => {
        const { scroll, closeIntegration } = this.state;

        if (!scroll && window.scrollY > 0) {
            // Zacali sme scrolovat
            this.setState({ scroll: true });
        } else if (scroll && window.scrollY === 0) {
            // Prestali sme scrolovat
            this.setState({ scroll: false });
        }

        if (!closeIntegration) {
            this.setState({ closeIntegration: true });
        }
    }

    /**
     * Ma precitane cookie?
     *
     * @return {boolean}
     */
    readCookies() {
        // Pozrieme sa ci mame ulozeny token
        const { cookies } = this.props;

        return !_.isUndefined(cookies.get(COOKIE_READ_NAME, COOKIE_SETTINGS));
    }

    /**
     * Scrolujeme navrch.
     */
    scrollToTop() {
        this.scrollTo(0);
    }

    /**
     * Scrolujeme na poziciu.
     *
     * @param {number} top
     */
    scrollTo(top) {
        window.scrollTo({ top, left: 0, behavior: 'smooth' });
    }

    /**
     * Scrolujeme na element.
     *
     * @param {Object} ref
     */
    scrollToElement(ref) {
        this.scrollTo(ref.current.offsetTop - 120);
    }

    /**
     * Zobrazime demo.
     */
    startDemo() {
        const { cookies } = this.props;

        // Ulozime token do cookie
        cookies.set(COOKIE_TOKEN_NAME, DEMO_TOKEN, COOKIE_SETTINGS);

        window.location = '/dashboard';
    }

    /**
     * Event po zmene blog kategorie.
     *
     * @param {string} blogCategory
     */
    onChangeBlogCategory(blogCategory) {
        this.setState({ blogCategory });
    }

    /**
     * Akceptacia cookies.
     */
    acceptCookies() {
        const { cookies } = this.props;

        this.setState({ readCookies: true });

        // Ulozime token do cookie
        cookies.set(COOKIE_READ_NAME, 'yes', COOKIE_SETTINGS);
    }

    getPrice(quantity = 1, manual = false) {
        if (manual) {
            return MARKET === 'cz'
                ? MANUAL_PRICE_CZ * quantity
                : (MARKET === 'pl'
                    ? MANUAL_PRICE_PL * quantity
                    : (MARKET === 'hu'
                        ? MANUAL_PRICE_HU * quantity
                        : MANUAL_PRICE * quantity));
        }

        return MARKET === 'cz'
            ? PRICE_CZ * quantity
            : (MARKET === 'pl'
                ? PRICE_PL * quantity
                : (MARKET === 'hu'
                    ? PRICE_HU * quantity
                    : PRICE * quantity));
    }

    /**
     * Vratime zlavu.
     *
     * @return {number}
     */
    getDiscount() {
        return MARKET === 'cz'
            ? 250
            : (MARKET === 'pl'
                ? 47
                : (MARKET === 'hu'
                    ? 4000
                    : 10));
    }

    /**
     * Rendrujeme sluzbu.
     *
     * @param {string} title
     * @param {string} img
     * @param {string} color
     * @param {Object} positions
     *
     * @return {JSX.Element}
     */
    renderService(title, img, color, positions = {}) {
        if (positions === null) {
            return null;
        }

        let style = { backgroundColor: color };

        if (!_.isEmpty(positions)) {
            style = { ...style, ...positions };
        }

        return (
            <div
                className="extension"
                style={style}
                key={title}
            >
                <Tooltip title={title}>
                    <img
                        className="extension__img"
                        src={IMAGES[img]}
                        alt={title}
                    />
                </Tooltip>
            </div>
        );
    }

    /**
     * Rendrujeme blog.
     *
     * @return {JSX.Element}
     */
    renderBlog() {
        const { blogCategory, blogArticle } = this.state;

        if (blogArticle !== null) {
            // Zobrazujeme clanok
            const article = this.blogArticles[blogArticle];
            const image = `article-${article.id}.png`;

            return (
                <div className="public blog">
                    <div className="public__header">
                        {this.renderMenu()}
                    </div>
                    <div className="public__article">
                        <div className="public__article__content">
                            {global.token === '' ? <Breadcrumbs className="sections">
                                <Link to="/">{__('Hlavná stránka')}</Link>
                                <Link to="/blog">{__('Blog')}</Link>
                                <Link to={`/blog/${article.uri}`}>{article.name}</Link>
                            </Breadcrumbs> : null}
                            <div className="public__article__content__photo" style={{ backgroundColor: article.background }}>
                                <img
                                    src={_.has(IMAGES, image) ? IMAGES[image] : IMAGES['article-1.png']}
                                    alt={article.name}
                                />
                            </div>
                            <div className="public__article__content__title">{article.name}</div>
                            <div
                                className="public__article__content__text"
                                dangerouslySetInnerHTML={{ __html: article.text }}
                            />
                        </div>
                        <div className="public__article__list">
                            {this.renderArticles(4)}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="public blog">
                <div className="public__header">
                    {this.renderMenu()}
                </div>
                <div className="public__blog">
                    <div className="public__blog__title">{__('Blog')}</div>
                    <div className="public__blog__text">{__('Na tejto stránke nájdete novinky z nášho systému, návody na aktivácie eshopov, ekonomických systémom, skladov, bánk, platobných brán a mnoho iného.')}</div>
                    <div className="public__blog__categories">
                        {_.map(this.blogCategories, (name, key) => {
                            return (
                                <Button
                                    onClick={() => this.onChangeBlogCategory(key)}
                                    key={key}
                                    className={key === blogCategory ? 'active' : ''}
                                >{name}</Button>
                            );
                        })}
                    </div>
                    {this.renderArticles()}
                </div>
            </div>
        );
    }

    /**
     * Rendrujeme cases.
     *
     * @return {JSX.Element}
     */
    renderAllCases() {
        const { casesArticle } = this.state;

        if (casesArticle !== null) {
            // Zobrazujeme clanok
            const article = this.cases[casesArticle];
            const image = `case-${article.id}.jpg`;

            return (
                <div className="public cases">
                    <div className="public__header">
                        {this.renderMenu()}
                    </div>
                    <div className="public__case">
                        <div className="public__case__content">
                            {global.token === '' ? <Breadcrumbs className="sections">
                                <Link to="/">{__('Hlavná stránka')}</Link>
                                <Link to="/cases">{__('Prípadové štúdie')}</Link>
                                <Link to={`/cases/${article.uri}`}>{article.name}</Link>
                            </Breadcrumbs> : null}
                            <div className="public__case__content__photo">
                                <img src={IMAGES[image]} alt={article.name} />
                            </div>
                            <div className="public__case__content__title">{article.name}</div>
                            <div className="public__case__content__info">
                                <a href={article.url} target="_blank" className="public__case__content__info__link">{article.urlName}</a>
                                <div className="public__case__content__info__countries">
                                    {_.map(article.countries, country => <ReactCountryFlag countryCode={country} svg />)}
                                </div>
                            </div>
                            <div
                                className="public__case__content__text"
                                dangerouslySetInnerHTML={{ __html: article.text }}
                            />
                        </div>
                        <div className="public__case__list">
                            {this.renderCases(3)}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="public cases">
                <div className="public__header">
                    {this.renderMenu()}
                </div>
                <div className="public__cases">
                    <div className="public__cases__title">{__('Prípadové štúdie')}</div>
                    <div className="public__cases__text">{__('Naše riešenia menia biznisy k lepšiemu. Pozrite si reálne príbehy našich klientov a zistite, ako sme im pomohli zefektívniť procesy, zvýšiť predaje a automatizovať každodenné úkony.')}</div>
                    {this.renderCases()}
                </div>
            </div>
        );
    }

    /**
     * Rendrujeme affiliate.
     *
     * @return {JSX.Element}
     */
    renderAffiliate() {
        const { affiliateClients } = this.state;

        // Cena
        const price = this.getPrice(12);
        const currency = MARKET === 'cz' ? 'CZK' : 'EUR';

        return (
            <div className="public affiliate">
                <div className="public__header">
                    {this.renderMenu()}
                </div>
                <div className="public__affiliate">
                    <div className="public__affiliate__title">{__('Staňte sa naším affiliate partnerom a zarábajte s nami')}</div>
                    <div className="public__affiliate__text">{__('Chcete si vytvoriť stabilný pasívny príjem? Zapojte sa do nášho affiliate programu a získajte odmenu za každého zákazníka, ktorého k nám privediete.')}</div>
                    <div className="public__affiliate__subtext">{__('30% z každej platby pre vás :)')}</div>
                    <div className="public__affiliate__panel">
                        <div
                            className="public__affiliate__panel__text"
                            dangerouslySetInnerHTML={{ __html: __('<h2>Ako to funguje?</h2><ul><li>Zaregistrujete sa do affiliate programu</li><li>Získate unikátny odkaz na propagáciu našich služieb</li><li>Privediete zákazníka, ktorý si aktivuje platené členstvo</li><li>Získavate doživotnú províziu vo výške 30 % z každej platby</li></ul><h2>Prečo sa zapojiť?</h2><ul><li>30 % doživotná provízia z každého aktívneho zákazníka</li><li>Jednoduchá propagácia našich služieb</li><li>Prehľadný affiliate portál</li><li>Pasívny príjem bez ďalšej práce</li></ul><h2>Pridajte sa k nám ešte dnes!</h2><p>Zaregistrujte sa do affiliate programu a začnite zarábať už teraz</p><h2>Vypočítajte si sumu provízie:</h2>') }}
                        />
                        <div className="public__affiliate__panel__text-info">{__('V príklade je uvedená platba ročného členstva Automat v sume:')} {formatAmount(price, currency)}</div>
                        <div className="public__affiliate__panel__slider">
                            <Slider
                                onChange={(event, value) => this.setState({ affiliateClients: value })}
                                defaultValue={affiliateClients}
                                valueLabelDisplay="auto"
                                min={1}
                                max={100}
                            />
                        </div>
                        <div className="public__affiliate__panel__info">
                            <div className="public__affiliate__panel__info__value">
                                <span>{__('Počet zákazníkov')}:</span>
                                <span>{affiliateClients}</span>
                            </div>
                            <div className="public__affiliate__panel__info__value">
                                <span>{__('Vaša provízia')}:</span>
                                <span>+{formatAmount(price * toNumber(affiliateClients) * 0.3, currency)}</span>
                            </div>
                        </div>
                        <Button
                            onClick={() => this.showLightbox('affiliate')}
                            color="green"
                        >{__('Stať sa partnerom')}</Button>
                    </div>
                </div>
                {this.renderLightbox(
                    'affiliate',
                    __('Affiliate program'),
                    <div className="affiliate-lightbox">{__('Aktuálne si vyberáme partnerov pre náš Affiliate program. Ak by ste mali záujem tak nás prosím kontaktujte na')}<a href={`mailto:info@goodeshop.${MARKET}`}>info@goodeshop.{MARKET}</a></div>,
                    '',
                    __('Zrušiť'),
                )}
            </div>
        );
    }

    /**
     * Rendrujeme branding.
     *
     * @return {JSX.Element}
     */
    renderBranding() {
        return (
            <div className="public branding">
                <div className="public__header">
                    {this.renderMenu()}
                </div>
                <div className="public__branding">
                    <div className="public__branding__title">{__('Branding')}</div>
                    <div className="public__branding__text">{__('Ak ste digitálna agentúra alebo webové štúdio vieme vám poskytnúť náš systém obrandovaný pod vašou značkou.')}</div>
                    <div className="public__branding__subtext">{__('Vyriešime za vás napojenia na externé systémy a mnoho iných funkcií pre vaše eshopy :)')}</div>
                    <div className="public__branding__windows">
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Vlastná doména')}</div>
                            <div className="public__branding__windows__panel__text">{__('Podporujeme nastavenie DNS záznamu pre subdoménu na vašej strane.')}</div>
                        </div>
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Vlastné logo a farby')}</div>
                            <div className="public__branding__windows__panel__text">{__('Nastavíme vám vaše logo a farby miesto tých našich.')}</div>
                        </div>
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Fakturujeme priamo vám')}</div>
                            <div className="public__branding__windows__panel__text">{__('My vám budeme fakturovať našu cenu za každý eshop. Vaše eshopy si budete spoplatnovať na vašej strane.')}</div>
                        </div>
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Správa systému')}</div>
                            <div className="public__branding__windows__panel__text">{__('Systém spravujeme stále my aj poskytujeme technickú podporu pri riešení problémov.')}</div>
                        </div>
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Verejná stránka a cenník')}</div>
                            <div className="public__branding__windows__panel__text">{__('Takéto údaje vaši klienti priamo nevidia. Majú dostupný len prihlasovací formulár z verejných stránok.')}</div>
                        </div>
                        <div className="public__branding__windows__panel">
                            <div className="public__branding__windows__panel__title">{__('Všetko pod hlavným účtom')}</div>
                            <div className="public__branding__windows__panel__text">{__('Vám ako agentúre nastavíme hlavný účet cez ktorý budete vedieť pristupovať ku všetkým vašim eshopom.')}</div>
                        </div>
                    </div>
                    <Button
                        onClick={() => this.showLightbox('branding')}
                        color="green"
                    >{__('Ideme do toho!')}</Button>
                </div>
                {this.renderLightbox(
                    'branding',
                    __('Branding'),
                    <div className="branding-lightbox">{__('Ak by ste mali záujem tak nás prosím kontaktujte na')}<a href={`mailto:info@goodeshop.${MARKET}`}>info@goodeshop.{MARKET}</a></div>,
                    '',
                    __('Zrušiť'),
                )}
            </div>
        );
    }

    /**
     * Rendrujeme clanky.
     *
     * @param {number} limit
     *
     * @return {JSX.Element}
     */
    renderArticles(limit = 0) {
        const { blogCategory } = this.state;

        let articles = this.blogArticles;
        let counter = 0;

        if (limit > 0) {
            // Mame limit, urobime nahodne poradie
            articles = this.shuffledArticles !== null ? this.shuffledArticles : _.shuffle(articles);

            this.shuffledArticles = articles;
        }

        return (
            <div className="articles">
                {_.map(articles, ({ id, uri, category, name, text }) => {
                    counter++;

                    if (limit > 0 && counter > limit) {
                        // Nezobrazujeme
                        return null;
                    }

                    const image = `article-${id}.png`;

                    if (blogCategory !== 'all' && blogCategory !== category) {
                        // Nezobrazujeme
                        return null;
                    }

                    return (
                        <ButtonBase
                            onClick={() => this.redirect(`/blog/${uri}`)}
                            className="articles__article"
                            key={uri}
                        >
                            <img
                                src={_.has(IMAGES, image) ? IMAGES[image] : IMAGES['article-1.png']}
                                alt={name}
                            />
                            <div className="articles__article__content">
                                <div className="articles__article__content__category">{this.blogCategories[category]}</div>
                                <div className="articles__article__content__name">{name}</div>
                                <div className="articles__article__content__text"
                                     dangerouslySetInnerHTML={{ __html: _.truncate(text.replace('<p>', '').replace('</p>', '').replace(/<a.*?<\/a>/g, ''), { length: 130 }) }}
                                />
                                <div className="articles__article__content__button">
                                    <ArrowRightIcon />
                                    <span>{__('Prečítať článok')}</span>
                                </div>
                            </div>
                        </ButtonBase>
                    );
                })}
            </div>
        );
    }

    renderCases(limit = 0) {
        let cases = this.cases;
        let counter = 0;

        if (limit > 0) {
            // Mame limit, urobime nahodne poradie
            cases = this.shuffledCases !== null ? this.shuffledCases : _.shuffle(_.toArray(cases));

            this.shuffledCases = cases;
        }

        return (
            <div className="cases">
                {_.map(cases, ({ id, uri, name, short, url, urlName, countries }) => {
                    counter++;

                    if (limit > 0 && counter > limit) {
                        // Nezobrazujeme
                        return null;
                    }

                    const image = `case-${id}.jpg`;

                    return (
                        <ButtonBase
                            onClick={() => this.redirect(`/cases/${uri}`)}
                            className="cases__case"
                            key={uri}
                        >
                            <div className="cases__case__photo">
                                <img src={IMAGES[image]} alt={name} />
                            </div>
                            <div className="cases__case__content">
                                <div className="cases__case__content__name">{name}</div>
                                <div className="cases__case__content__info">
                                    <a href={url} target="_blank" className="cases__case__content__info__link">{urlName}</a>
                                    <div className="cases__case__content__info__countries">
                                        {_.map(countries, country => <ReactCountryFlag countryCode={country} svg />)}
                                    </div>
                                </div>
                                <div className="cases__case__content__text">{short}</div>
                                <div className="cases__case__content__button">
                                    <ArrowRightIcon />
                                    <span>{__('Prečítať viac')}</span>
                                </div>
                            </div>
                        </ButtonBase>
                    );
                })}
            </div>
        );
    }

    /**
     * Rendrujeme menu.
     *
     * @return {JSX.Element}
     */
    renderMenu() {
        const { scroll, blog, affiliate, branding, cases } = this.state;

        // Zobrazujeme webareal?
        const isWebareal = this.isWebareal();

        let loginButton = <Button
            onClick={() => this.redirect(affiliate ? '/affiliate-login' : '/login')}
            className="login-button"
        >{__('Prihlásenie')}</Button>;

        if ((cases || blog) && this.isMobile()) {
            loginButton = <Button
                onClick={() => this.redirect('/')}
                className="login-button"
            >{__('Hlavná stránka')}</Button>;
        }

        return (
            <div className={`public__header__menu ${scroll ? 'menu__mini' : ''}`}>
                <div className="public__header__menu__content">
                    <Logo
                        onClick={this.isMobile() ? () => { window.location = '/'; } : () => this.scrollToTop()}
                        color="dark"
                        className="public__header__menu__content__logo"
                    />
                    <div className="public__header__menu__content__buttons">
                        {!blog && !cases && !affiliate && !branding ? <Button onClick={() => this.scrollToElement(this.infoRef)}>{__('Naše riešenie')}</Button> : null}
                        {!blog && !cases && !affiliate && !branding ? <Button onClick={() => this.scrollToElement(this.clientsRef)}>{__('Úspešné príbehy')}</Button> : null}
                        {!blog && !cases && !affiliate && !branding ? <Button onClick={() => this.scrollToElement(this.integrationRef)}>{__('Integrácie')}</Button> : null}
                        {!blog && !cases && !affiliate && !branding ? <Button onClick={() => this.scrollToElement(this.pricingRef)}>{__('Cenník')}</Button> : null}
                        {!blog && !cases && !affiliate && !branding
                            ? null
                            : (global.token === '' ? <Button onClick={() => this.redirect('/')}>{__('Naspäť na hlavnú stránku')}</Button> : null)}
                        {global.token === '' && !isWebareal ? loginButton : null}
                    </div>
                    <div className="public__header__menu__content__trial">
                        {global.token === '' && !isWebareal ? <Button
                            onClick={affiliate
                                ? () => this.showLightbox('affiliate')
                                : (branding ? () => this.showLightbox('branding') : () => this.redirect('/register'))}
                            color="green"
                        >{affiliate
                            ? __('Stať sa partnerom')
                            : (branding ? __('Ideme do toho!') : __('7 dní zdarma'))}</Button> : null}
                        {isWebareal ? loginButton : null}
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Rendrovanie.
     *
     * @returns {JSX.Element}
     */
    render() {
        const { stats, blog, affiliate, readCookies, tab, branding, cases, closeIntegration } = this.state;
        const { cookies, params } = this.props;

        if (_.isEmpty(stats)) {
            // Nemame stats, zobrazime loading
            return <div className="public">{this.renderLoading()}</div>;
        }

        if (blog) {
            // Zobrazujeme blog
            return this.renderBlog();
        } else if (cases) {
            // Zobrazujeme cases
            return this.renderAllCases();
        } else if (affiliate) {
            // Zobrazujeme affiliate
            return this.renderAffiliate();
        } else if (branding) {
            // Zobrazujeme branding
            return this.renderBranding();
        }

        // VOP url
        const vopUrl = MARKET === 'cz' ? '/vop-cz.pdf?v=3' : '/vop.pdf?v=3';

        const privacyUrl = MARKET === 'cz' ? '/privacy-cz.pdf?v=3' : '/privacy.pdf?v=3';

        // Vytiahneme zdroj
        const source = cookies.get(COOKIE_SOURCE_NAME, COOKIE_SETTINGS);

        // TODO::
        const showIntegration = _.has(params, 'integration') && params.integration === 'ppl';

        return (
            <div className="public">
                <div className="public__header">
                    <div className="public__header__head-message">{this.isMobile() ? __('Všetko nastavíme za vás. Úplne zadarmo.') : __('Naši odborníci vám zadarmo pomôžu so všetkými nastaveniami a prepojeniami. Kontaktuje nás.')}</div>
                    <div className="public__header__head">
                        <div className="public__header__head__content">
                            <div className="public__header__head__content__countries">
                                <a href={`https://goodeshop.sk${!_.isEmpty(source) ? ('?source=' + source) : ''}`}><ReactCountryFlag countryCode="SK" svg /></a>
                                <a href={`https://goodeshop.cz${!_.isEmpty(source) ? ('?source=' + source) : ''}`}><ReactCountryFlag countryCode="CZ" svg /></a>
                            </div>
                            <div className="public__header__head__content__buttons">
                                <ButtonBase onClick={() => this.redirect('/branding')}>{__('Branding')}</ButtonBase>
                                <ButtonBase onClick={() => this.redirect('/affiliate')}>{__('Affiliate program')}</ButtonBase>
                                <ButtonBase onClick={() => this.redirect('/blog/map')}>{__('Mapa výdajných miest')}</ButtonBase>
                                <ButtonBase onClick={() => this.redirect('/cases')}>{__('Prípadové štúdie')}</ButtonBase>
                                <ButtonBase onClick={() => this.redirect('/blog')} className="public__header__head__content__buttons__show-mobile">{__('Blog')}</ButtonBase>
                                <ButtonBase onClick={() => this.scrollToElement(this.contactRef)} className="public__header__head__content__buttons__show-mobile">{__('Kontakt')}</ButtonBase>
                            </div>
                        </div>
                    </div>
                    {this.renderMenu()}
                    <div className="public__header__content">
                        <div className="public__header__content__slogan">{__('Pomáhame eshopom :)')}</div>
                        <div className="public__header__content__title">{__('Posuňte svoj')}<span>{__('eshop')}</span></div>
                        <div className="public__header__content__subtitle">{__('na vyšší')}<span>{__('level')}</span></div>
                        <div className="public__header__content__text">{__('Jednoduchá správa eshopu a prepojení na jednom mieste.')}</div>
                        <Button onClick={() => this.startDemo()}>{__('Vyskúšať DEMO účet')}</Button>
                        <img src={IMAGES['public.png']} alt="public" />
                        {_.map(ESHOPS, (name, key) => {
                            if (key === 'Blank') {
                                return null;
                            }

                            return this.renderService(name, `${key.toLowerCase()}.png`, ESHOP_COLORS[key].background, _.has(ESHOP_POSITIONS, key) ? ESHOP_POSITIONS[key] : null );
                        })}
                        {_.map(COURIERS, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, COURIER_COLORS[key].background, _.has(COURIER_POSITIONS, key) ? COURIER_POSITIONS[key] : null ))}
                        {_.map(ACCOUNTINGS, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, ACCOUNTING_COLORS[key].background, _.has(ACCOUNTING_POSITIONS, key) ? ACCOUNTING_POSITIONS[key] : null ))}
                        {_.map(BANKS, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, BANK_COLORS[key].background, _.has(BANK_POSITIONS, key) ? BANK_POSITIONS[key] : null ))}
                        {_.map(GATEWAYS, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, GATEWAYS_COLORS[key].background, _.has(GATEWAYS_POSITIONS, key) ? GATEWAYS_POSITIONS[key] : null ))}
                        {_.map(MARKETPLACES, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, MARKETPLACES_COLORS[key].background, _.has(MARKETPLACES_POSITIONS, key) ? MARKETPLACES_POSITIONS[key] : null ))}
                    </div>
                    {!closeIntegration && showIntegration ? <div className="public__header__integration">
                        <div className="public__header__integration__window">
                            <div className="public__header__integration__window__panel">
                                <div className="public__header__integration__window__panel__logo">
                                    <img src={IMAGES[`ppl.png`]} alt="ppl" />
                                </div>
                                <div className="public__header__integration__window__panel__title">{__('Integrácia')} GoodEshop & PPL</div>
                                <div className="public__header__integration__window__panel__text">{__('Prepojte svoj PPL účet s platformou GoodEshop')}</div>
                                <div className="public__header__integration__window__panel__subtitle">{__('Prepojíme vás s eshopmi')}:</div>
                                <div className="public__header__integration__window__panel__services">
                                    {_.map(ESHOPS, (name, key) => {
                                        if (key === 'Blank') {
                                            return null;
                                        }

                                        return this.renderService(name, `${key.toLowerCase()}.png`, ESHOP_COLORS[key].background );
                                    })}
                                </div>
                            </div>
                            <div className="public__header__integration__window__text">
                                <div className="public__header__integration__window__text__main">{__('Prepojte svoj PPL účet s platformou GoodEshop a zefektívnite si expedíciu objednávok. Zjednoťte spracovanie zásielok od viacerých prepravcov aj z rôznych predajných kanálov v jednom prehľadnom systéme. Vďaka napojeniu PPL na GoodEshop môžete odosielať balíky rýchlo a jednoducho – jednotlivo, vo väčších dávkach.')}</div>
                                <div className="public__header__integration__window__text__title">{__('Aké funkcie poskytujeme?')}</div>
                                <div className="public__header__integration__window__text__function">
                                    <div className="public__header__integration__window__text__function__icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="public__header__integration__window__text__function__text">{__('Vytvorenie zásielok z vašich objednávok a tlač štítkov')}</div>
                                </div>
                                <div className="public__header__integration__window__text__function">
                                    <div className="public__header__integration__window__text__function__icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="public__header__integration__window__text__function__text">{__('Automatické preposlanie čísla zásielky do eshopu alebo na trhovisko')}</div>
                                </div>
                                <div className="public__header__integration__window__text__function">
                                    <div className="public__header__integration__window__text__function__icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="public__header__integration__window__text__function__text">{__('Monitoring doručenia zásielky a následne automatické akcie (zmena stavu objednávky, vystavenie faktúry)')}</div>
                                </div>
                                <div className="public__header__integration__window__text__function">
                                    <div className="public__header__integration__window__text__function__icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="public__header__integration__window__text__function__text">{__('Integráciu mapy s výdajnými miestami do vášho eshopu')}</div>
                                </div>
                                <div className="public__header__integration__window__text__function">
                                    <div className="public__header__integration__window__text__function__icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="public__header__integration__window__text__function__text">{__('Zobrazenie odkazu na sledovanie zásielky na stránke verejnej objednávky ktorú poskytujeme')}</div>
                                </div>
                            </div>
                            <IconButton onClick={() => this.setState({ closeIntegration: true })}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div> : null}
                </div>
                <div className="public__windows">
                    <div className="public__windows__logos-title">{__('Aj tieto spoločnosti rastú s nami')}</div>
                    <div className="public__windows__logos">
                        <img src={IMAGES['clients-2.png']} alt="client logo 2" />
                        <img src={IMAGES['clients-3.png']} alt="client logo 3" />
                        <img src={IMAGES['clients-6.png']} alt="client logo 6" />
                        <img src={IMAGES['clients-7.png']} alt="client logo 7" />
                        <img src={IMAGES['clients-9.png']} alt="client logo 9" />
                        <img src={IMAGES['clients-10.png']} alt="client logo 10" />
                        <img src={IMAGES['clients-12.png']} alt="client logo 12" />
                    </div>
                    <div className="public__windows__logos-subtitle">{__('a 1000+ dalších eshopov')}</div>
                    <div className="public__windows__text">
                        <div>{__('Riadiť eshop nikdy nebolo jednoduchšie. S naším systémom zvládnete objednávky, faktúry, sklady aj prepravu na pár klikov.')}</div>
                        <div>{__('Sme tu pre vás – kedykoľvek cez AI asistenta alebo náš tím odborníkov.')}</div>
                    </div>
                    <div className="public__windows__panels">
                        <div className="public__windows__panels__panel">
                            <div className="public__windows__panels__panel__icon">
                                <RoofingIcon />
                            </div>
                            <div className="public__windows__panels__panel__title">{__('Pod jednou strechou')}</div>
                            <div className="public__windows__panels__panel__text">{__('Všetky prepojenia eshopu pod kontrolou, na jednom mieste, pre vás a váš tím.')}</div>
                        </div>
                        <div className="public__windows__panels__panel">
                            <div className="public__windows__panels__panel__icon">
                                <CloudDoneIcon />
                            </div>
                            <div className="public__windows__panels__panel__title">{__('Prehladnosť a dostupnosť')}</div>
                            <div className="public__windows__panels__panel__text">{__('Naša aplikácia je prehľadná, rýchla a dáta vášho eshopu sú vám dostupné 24/7.')}</div>
                        </div>
                        <div className="public__windows__panels__panel">
                            <div className="public__windows__panels__panel__icon">
                                <SmartToyIcon />
                            </div>
                            <div className="public__windows__panels__panel__title">{__('Automatizácia a bezpečnosť')}</div>
                            <div className="public__windows__panels__panel__text">{__('Automatizujeme procesy a zabezpečujeme vaše dáta špičkovou kryptografiou.')}</div>
                        </div>
                    </div>
                </div>
                <div className="public__info" ref={this.infoRef}>
                    <div className="public__info__title">{__('Naše riešenie')}</div>
                    <div className="public__info__text">{__('Dostupné odkiaľkoľvek aj na mobiloch.')}</div>
                    <Tabs
                        value={tab}
                        onChange={(event, tab) => this.setState({ tab })}
                        className="public__info__tabs"
                    >
                        <Tab label={__('Správa objednávok')} value="orders" />
                        <Tab label={__('Fakturácia')} value="invoices" />
                        <Tab label={__('Sklad a produkty')} value="products" />
                        <Tab label={__('Expedícia zásielok')} value="packages" />
                        <Tab label={__('Sledovanie objednávky')} value="track" />
                    </Tabs>
                    <div className="public__info__tabs-content">
                        <div className="public__info__tabs-content__panel">
                            <div className="public__info__tabs-content__panel__title">{this.tabs[tab][0].title}</div>
                            <div className="public__info__tabs-content__panel__text">{this.tabs[tab][0].text}</div>
                        </div>
                        <div className="public__info__tabs-content__panel">
                            <div className="public__info__tabs-content__panel__title">{this.tabs[tab][1].title}</div>
                            <div className="public__info__tabs-content__panel__text">{this.tabs[tab][1].text}</div>
                        </div>
                        <div className="public__info__tabs-content__panel">
                            <div className="public__info__tabs-content__panel__title">{this.tabs[tab][2].title}</div>
                            <div className="public__info__tabs-content__panel__text">{this.tabs[tab][2].text}</div>
                        </div>
                    </div>
                    <div className="public__info__bigtext">
                        <div>{__('Pripravili sme pre vás DEMO účet s testovacími objednávkami na ktorých si môžete vyskúšať našu službu.')}</div>
                        <div>{__('Stačí kliknúť nižšie na tlačítko.')}</div>
                    </div>
                    <div className="public__info__extensions-text">{__('Aktívne napojenia na DEMO účte')}</div>
                    <div className="public__info__extensions">
                        {this.renderService(ESHOPS.WooCommerce, 'woocommerce.png', ESHOP_COLORS.WooCommerce.background)}
                        {this.renderService(ACCOUNTINGS.SuperFaktura, 'superfaktura.png', ACCOUNTING_COLORS.SuperFaktura.background)}
                        {this.renderService(COURIERS.Depo, 'depo.png', COURIER_COLORS.Depo.background)}
                    </div>
                    <Button onClick={() => this.startDemo()}>{__('Vyskúšať DEMO účet')}</Button>
                </div>
                <div className="public__clients" ref={this.clientsRef}>
                    <div className="public__clients__title">{__('Stovky spokojných klientov')}</div>
                    <div className="public__clients__text">
                        <div>{__('Uvedomujeme si, že každý eshop má svoje jedinečné požiadavky a potreby. Preto sme náš systém vyvinuli tak, aby bol flexibilný a prispôsobiteľný konkrétnym požiadavkám.')}</div>
                        <div>{__('Naši odborníci sa zameriavajú na to, aby sme dokázali prispôsobiť riešenie presne podľa vašich potrieb, čo považujeme za našu najväčšiu konkurenčnú výhodu, ktorú vám žiadny iný softvér neposkytne.')}</div>
                    </div>
                    <div className="public__clients__testimonial">
                        <div>“{__('Vďaka riešeniu od GOODESHOP sa nám podarilo plne zautomatizovať prepojenie medzi eshopom a ERP systémom. Objednávky, produkty aj skladové zásoby sa teraz synchronizujú bez manuálnej práce, čo nám šetrí čas a znižuje chybovosť. Oceňujeme predovšetkým inteligentný systém na sledovanie cenových zmien, ktorý nám výrazne uľahčil preceňovanie produktov. Navyše sa len málokedy stretnete s takou technickou kvalitou a časovou flexibilitou, akú GOODESHOP ponúka. Spoluprácu rozhodne odporúčame.')}”</div>
                        <div>{__('Tomáš Frčka')}, <a href="https://www.meetyshop.com" target="_blank">meetyshop.com</a></div>
                    </div>
                    <div className="public__clients__panels">
                        {_.map(_.slice(_.toArray(this.cases), 0, 3), item => {
                            return (
                                <div className="public__clients__panels__panel" key={item.id}>
                                    <div className="public__clients__panels__panel__photo">
                                        <img className="public__clients__panels__panel__photo__background" src={IMAGES[`case-${item.id}.jpg`]} alt={`case ${item.id}`} />
                                    </div>
                                    <div className="public__clients__panels__panel__title">{item.name}</div>
                                    <div className="public__clients__panels__panel__info">
                                        <a href={item.url} target="_blank" className="public__clients__panels__panel__info__link">{item.urlName}</a>
                                        <div className="public__clients__panels__panel__info__countries">
                                            {_.map(item.countries, country => <ReactCountryFlag countryCode={country} svg />)}
                                        </div>
                                    </div>
                                    <div className="public__clients__panels__panel__text">{item.short}</div>
                                    <ButtonBase onClick={() => this.redirect(`/cases/${item.uri}`)} className="public__clients__panels__panel__button">
                                        <ArrowRightIcon />
                                        <span>{__('Prečítať viac')}</span>
                                    </ButtonBase>
                                </div>
                            );
                        })}
                    </div>
                    <Button onClick={() => this.redirect('/cases')}>{__('Viac príbehov')}</Button>
                </div>
                <div className="public__integrations" ref={this.integrationRef}>
                    <div className="public__integrations__title">{__('Integrácie pre vás')}</div>
                    <div className="public__integrations__text">{__('Potrebujete iné riešenie?')}<br />{__('Kontaktujte nás a zadarmo doplníme :)')}</div>
                    <div className="public__integrations__panels">
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Eshopy')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map(ESHOPS, (name, key) => {
                                    if (key === 'Blank') {
                                        return null;
                                    }

                                    return this.renderService(name, `${key.toLowerCase()}.png`, ESHOP_COLORS[key].background);
                                })}
                            </div>
                        </div>
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Ekonomika')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map(ACCOUNTINGS, (name, key) => {
                                    if (key === 'Kros' || key === 'Inteo') {
                                        // Nezobrazujeme
                                        return null;
                                    }

                                    return this.renderService(name, `${key.toLowerCase()}.png`, ACCOUNTING_COLORS[key].background);
                                })}
                            </div>
                        </div>
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Prepravcovia')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map(COURIERS, (name, key) => {
                                    if (key === 'Posta') {
                                        // Nezobrazujeme
                                        return null;
                                    }

                                    return this.renderService(name, `${key.toLowerCase()}.png`, COURIER_COLORS[key].background);
                                })}
                            </div>
                        </div>
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Sklady')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map(STORAGES, (name, key) => _.has(STORAGE_COLORS, key) ? this.renderService(name, `${key.toLowerCase()}.png`, STORAGE_COLORS[key].background) : null)}
                            </div>
                        </div>
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Banky')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map({ ...BANKS, ...GATEWAYS }, (name, key) => this.renderService(name, `${key.toLowerCase()}.png`, _.has(BANK_COLORS, key)
                                    ? BANK_COLORS[key].background
                                    : GATEWAYS_COLORS[key].background))}
                            </div>
                        </div>
                        <div className="public__integrations__panels__panel">
                            <div className="public__integrations__panels__panel__title">{__('Trhoviská')}</div>
                            <div className="public__integrations__panels__panel__logos mini">
                                {_.map(MARKETPLACES, (name, key) => _.has(MARKETPLACES_COLORS, key) ? this.renderService(name, `${key.toLowerCase()}.png`, MARKETPLACES_COLORS[key].background) : null)}
                            </div>
                        </div>
                    </div>
                    <div className="public__integrations__api">
                        <div className="public__integrations__api__title">{__('Máte vlastné riešenie eshopu? Nevadí máme API.')}</div>
                        <Button onClick={() => window.open('https://goodeshop.docs.apiary.io/', '_blank')}>{__('API dokumentácia')}</Button>
                    </div>
                </div>
                <div className="public__map">
                    <div className="public__map__title">{__('Univerzálna mapa výdajných miest')}</div>
                    <div className="public__map__text">
                        <div>{__('Zjednodušte výber doručenia pre svojich zákazníkov. Naša univerzálna mapa umožňuje prehľadné zobrazenie a výber výdajných miest od viacerých prepravcov na jednom mieste.')}</div>
                        <div>{__('Jednoduchá integrácia do vášho eshopu, vyšší komfort pre vašich zákazníkov.')}</div>
                    </div>
                    <div className="public__map__couriers">
                        <div className="public__map__couriers__title">{__('Výdajné miesta poskytujeme pre')}:</div>
                        <div className="public__map__couriers__list">
                            {this.renderService(COURIERS.Zasielkovna, 'zasielkovna.png', COURIER_COLORS.Zasielkovna.background)}
                            {this.renderService(COURIERS.Gls, 'gls.png', COURIER_COLORS.Gls.background)}
                            {this.renderService(COURIERS.SlovenskaPosta, 'slovenskaposta.png', COURIER_COLORS.SlovenskaPosta.background)}
                            {this.renderService(COURIERS.Dpd, 'dpd.png', COURIER_COLORS.Dpd.background)}
                            {this.renderService(COURIERS.Ppl, 'ppl.png', COURIER_COLORS.Ppl.background)}
                            {this.renderService(COURIERS.Sps, 'sps.png', COURIER_COLORS.Sps.background)}
                            {this.renderService(COURIERS.Depo, 'depo.png', COURIER_COLORS.Depo.background)}
                            {this.renderService(COURIERS.Mpl, 'mpl.png', COURIER_COLORS.Mpl.background)}
                        </div>
                    </div>
                    <Button onClick={() => this.redirect('/blog/map')}>{__('Zobraziť viac')}</Button>
                </div>
                <div className="public__security">
                    <div className="public__security__title">{__('Vaše dáta v bezpečí!')}</div>
                    <div className="public__security__text">{__('Všetky vaše dáta sú u nás bezpečne zašifrované pomocou najnovších kryptografických technológií.')}</div>
                    <div className="public__security__bigtext">{__('Nižšie si môžete pozrieť, ako vyzerajú dáta uložené v našich systémoch. Všetky dáta sú zašifrované a nečitateľné pre našich zamestnancov ani potenciálnych útočníkov, ktorí by sa ich pokúsili získať. Dekomprimované sú až po vašom prihlásení a zobrazení v rámci vášho účtu. Vaše dáta sú u nás v bezpečí a nikdy ich neposkytujeme žiadnej tretej strane. Po zmazaní akýchkoľvek údajov z našich systémov sú tieto natrvalo odstránené, bez možnosti obnovy. Vaša bezpečnosť a súkromie sú pre nás najvyššou prioritou.')}</div>
                    <div className="public__security__panels">
                        <div className="public__security__panels__panel">
                            <div className="public__security__panels__panel__title">{__('Dáta z vášho eshopu')}</div>
                            <div className="public__security__panels__panel__data">{`{"client":{"id":"9daa0437","name":"Štefan Mrkva","phone":"+421909090909","zip":"83106"}}`}</div>
                        </div>
                        <div className="public__security__panels__panel">
                            <div className="public__security__panels__panel__title">{__('Dáta uložené v našom systéme')}</div>
                            <div className="public__security__panels__panel__data">{`mFKX9xqIlMeoHKri6sDFTkwLIJMPjATxFBzCmMTzEDne5wVy8NDSn2YZrk1mXARNLWLNyGxXEWdjJ2hQ2YTBdKiRlGwEK+EhhwfyzwoV9Dhq7YyLIyKA/nma1LWNWrfj`}</div>
                        </div>
                    </div>
                </div>
                {toNumber(stats.orders) > 0 ? <div className="public__stats">
                    <div className="public__stats__panels">
                        <div className="public__stats__panels__panel">
                            <span>{formatAmount(stats.orders, '', 0)}</span>
                            <span>{__('objednávok')}</span>
                        </div>
                        <div className="public__stats__panels__panel">
                            <span>{formatAmount(stats.invoices, '', 0)}</span>
                            <span>{__('faktúr')}</span>
                        </div>
                        <div className="public__stats__panels__panel">
                            <span>{formatAmount(stats.packages, '', 0)}</span>
                            <span>{__('zásielok')}</span>
                        </div>
                    </div>
                </div> : null}
                <div className="public__pricing" ref={this.pricingRef}>
                    <div className="public__pricing__title">{__('Koľko zaplatíte?')}</div>
                    <div className="public__pricing__text">{__('Žiadne skryté poplatky, len fixná suma.')}</div>
                    <div className="public__pricing__subtext">{__('Garancia vrátenia peňazí do 14 dní.')}</div>
                    <div className="public__pricing__panels">
                        <div className="public__pricing__panels__panel">
                            <div className="public__pricing__panels__panel__header">
                                <div className="public__pricing__panels__panel__header__name">{__('Manual')}</div>
                            </div>
                            <div className="public__pricing__panels__panel__text">{__('Ideálny pre menšie eshopy, ktoré si chcú procesy riadiť ručne a mať plnú kontrolu nad každou akciou.')}</div>
                            <div className="public__pricing__panels__panel__price">{formatAmount(this.getPrice(1, true), getCurrency())}</div>
                            <div className="public__pricing__panels__panel__price-text">{__('finálna mesačná platba')}</div>
                            <div className="public__pricing__panels__panel__functions">{_.map([
                                { name: __('Neobmedzené množstvo objednávok'), text: '' },
                                { name: __('Neobmedzené množstvo produktov'), text: '' },
                                { name: '🤖 ' + __('AI funkcionality - pripravujeme'), text: __('Generovanie názvov, popisov, SEO k produktom. Preklady na nové trhy.') },
                                { name: __('Fakturácia a evidencia úhrad'), text: '' },
                                { name: __('Odosielanie zásielok prepravcom'), text: '' },
                                { name: __('Univerzálna mapa pre výdajné miesta'), text: __('Poskytujeme univerzálny plugin s výberom výdajného miesta pre váš eshop.') },
                                { name: __('Načítanie objednávok z trhovísk'), text: '' },
                                { name: __('Mailing a exporty'), text: '' },
                                { name: __('Sledovanie objednávky'), text: __('Poskytujeme verejnú stránku pre každú vašu objednávku. Odkaz na stránku viete poslať zákazníkovi, nájde tam aktuálny stav objednávky, faktúru alebo číslo zásielky.') },
                                { name: __('Evidencia zamestnancov a práv'), text: '' },
                                { name: __('Evidencia reklamácii'), text: '' },
                            ], ({ name, text }, key) => {
                                return (
                                    <div className="public__pricing__panels__panel__functions__function" key={key}>
                                        <div className="public__pricing__panels__panel__functions__function__icon">
                                            <CheckIcon />
                                        </div>
                                        <div className="public__pricing__panels__panel__functions__function__info">
                                            <div className="public__pricing__panels__panel__functions__function__info__name">{name}</div>
                                            {text !== '' ? <div className="public__pricing__panels__panel__functions__function__info__text">{text}</div> : null}
                                        </div>
                                    </div>
                                );
                            })}</div>
                            <Button
                                onClick={() => this.redirect('/register')}
                                color="green"
                            >{__('7 dní zdarma')}</Button>
                        </div>
                        <div className="public__pricing__panels__panel">
                            <div className="public__pricing__panels__panel__header">
                                <div className="public__pricing__panels__panel__header__name">{__('Automat')}</div>
                                <div className="public__pricing__panels__panel__header__text">{__('Odporúčame')}</div>
                            </div>
                            <div className="public__pricing__panels__panel__text">{__('Navrhnutý pre rastúce eshopy, ktoré chcú ušetriť čas automatizáciou fakturácie, skladu, zmien stavov objednávok, odosielania e-mailov a ďalších procesov.')}</div>
                            <div className="public__pricing__panels__panel__price">{formatAmount(this.getPrice(), getCurrency())}</div>
                            <div className="public__pricing__panels__panel__price-text">{__('finálna mesačná platba')}</div>
                            <div className="public__pricing__panels__panel__functions">{_.map([
                                { name: __('Všetky funkcie z balíka Manual'), text: __('Vrátane neobmedzeného množstva objednávok a produktov.') },
                                { name: __('Automatizácia fakturácie'), text: '' },
                                { name: __('Synchronizácia produktov so skladom'), text: '' },
                                { name: __('Automatické odosielanie informácii na trhoviská'), text: __('Faktúry k objednávkam, čísla zásielok') },
                                { name: __('Párovanie úhrad z banky'), text: '' },
                                { name: __('Automatická zmena stavov objednávok'), text: '' },
                                { name: __('Monitoring doručenia zásielok'), text: '' },
                                { name: '🤖 ' + __('AI agenty - pripravujeme'), text: __('Vytvoríte si profil svojho AI zamestnanca a môžete mu zadávať pravidelné automatické úlohy.') },
                                { name: __('Automatické odosielanie emailov'), text: '' },
                                { name: __('Prenos čísla zásielky do eshopu'), text: '' },
                                { name: __('XML importy a monitoring cien dodávateľov'), text: __('Pripravujeme') },
                            ], ({ name, text }, key) => {
                                return (
                                    <div className="public__pricing__panels__panel__functions__function" key={key}>
                                        <div className="public__pricing__panels__panel__functions__function__icon">
                                            <CheckIcon />
                                        </div>
                                        <div className="public__pricing__panels__panel__functions__function__info">
                                            <div className="public__pricing__panels__panel__functions__function__info__name">{name}</div>
                                            {text !== '' ? <div className="public__pricing__panels__panel__functions__function__info__text">{text}</div> : null}
                                        </div>
                                    </div>
                                );
                            })}</div>
                            <Button
                                onClick={() => this.redirect('/register')}
                                color="green"
                            >{__('7 dní zdarma')}</Button>
                        </div>
                    </div>
                </div>
                <div className="public__contact" ref={this.contactRef}>
                    <div className="public__contact__title">
                        <span>{__('Máte otázky, potrebujete poradiť?')}</span><br />
                        <span>{__('Sme pripravení!')}</span>
                    </div>
                    <div className="public__contact__subtitle">
                        <span>{__('Náš AI kolega je k dispozícii kedykoľvek, aby vám pomohol. Naši ďalší kolegovia vám odpovedia do niekoľkých hodín.')}</span>
                    </div>
                    <ButtonBase onClick={() => { if (window.liveChatButton !== undefined) { window.liveChatButton.onClick(); } }} className="public__contact__chat">
                        <div className="public__contact__chat__icon">
                            <SupportAgentIcon />
                        </div>
                        <div className="public__contact__chat__value">{__('Live chat')}</div>
                    </ButtonBase>
                    <ButtonBase onClick={() => { window.location = `mailto:info@goodeshop.${MARKET}`}} className="public__contact__email">
                        <div className="public__contact__email__icon">
                            <EmailIcon />
                        </div>
                        <div className="public__contact__email__value">info@goodeshop.{MARKET}</div>
                    </ButtonBase>
                </div>
                <div className="public__trial">
                    <div className="public__trial__title">{__('Vyskúšajte nás na 7 dní zadarmo.')}</div>
                    <div className="public__trial__text">
                        <span>{__('Šetríme denne hodiny práce viac ako 1000 eshopom vo viac ako 8 krajinách.')}</span>
                    </div>
                    <Button
                        onClick={() => this.redirect('/register')}
                        color="green"
                    >{__('Vyskúšať zadarmo')}</Button>
                    <div className="public__trial__footer">
                        <Button onClick={() => this.redirect('/login')}>{__('Prihlásiť sa')}</Button>
                        <Button onClick={() => this.scrollToElement(this.contactRef)}>{__('Kontakt')}</Button>
                        <Button onClick={() => window.open(vopUrl, '_blank')}>{__('Obchodné podmienky')}</Button>
                        <Button onClick={() => window.open(privacyUrl, '_blank')}>{__('Spracovanie osobných údajov')}</Button>
                    </div>
                    <div className="public__trial__footer-text">Rac Development s.r.o., IČO: 56692293, Karpatské námestie 7770/10A, 83106 Bratislava</div>
                </div>
                {!readCookies ? <div className="public__cookies">
                    <div className="public__cookies__content">
                        <div className="public__cookies__content__text">{__('Súbory cookie používame k správnemu fungovaniu webu, pre reklamné a štatistické účely a k prispôsobeniu obsahu webu individuálnym potrebám užívateľa. Pokiaľ nesúhlasíte s používaním našich súborov cookie tak ich zakážte pre našu webovú stránku v nastaveniach svojho prehliadača.')}</div>
                        <Button
                            onClick={() => this.acceptCookies()}
                        >{__('Súhlasím')}</Button>
                    </div>
                </div> : null}
            </div>
        );
    }
}

const stateToProps = ({ user }) => ({ user });

export default withCookies(connect(stateToProps)(PublicScreen));
